import clsx from 'clsx'
import { Portal } from 'components/utility/portal'
import React, { useEffect, useRef, useState } from 'react'

const TABLE_CONTENTS = [
  {
    previousContent: 'Without Files',
    newContent: 'Generic Form',
  },
  {
    previousContent: 'With Files',
    newContent: 'lender, attorney/due diligence, appraise, other',
  },

  {
    previousContent: 'Both With and Without Files',
    newContent: 'All Form Types',
  },

  {
    previousContent: 'Custom Pricing',
    newContent: 'variable',
  },
]

const TableContentsItem = ({ previousContent, newContent }) => {
  return (
    <li style={{ background: '#F9F9F9', padding: 12 }}>
      <div className="dome-d-flex dome-align-center dome-gap18">
        <span className="dome-p2 dome-darkest-grey dome-flex-1">{previousContent}</span>
        <span>
          <i className="fa-sharp-duotone fa-light fa-arrow-right dome-color-lite-grey"></i>
        </span>
        <span className="dome-p2 dome-darkest-grey dome-flex-1">{newContent} </span>
      </div>
    </li>
  )
}

const TableContents = () => {
  return (
    <div className="dome-d-flex dome-flex-column">
      <div
        style={{
          padding: '0 12px 3px 12px',
          borderBottom: '1px solid var(--med-grey, #898989)',
        }}
      >
        <div className="dome-d-flex dome-gap18">
          <span className="dome-p3 dome-color-med-grey dome-flex-1">previous term</span>
          <div style={{ width: 12 }}></div>
          <span className="dome-p3 dome-color-med-grey dome-flex-1">new term</span>
        </div>
      </div>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {TABLE_CONTENTS.map(({ previousContent, newContent }, index) => (
          <TableContentsItem key={index} previousContent={previousContent} newContent={newContent} />
        ))}
      </ul>
    </div>
  )
}

const Terminology = ({ onSave }) => {
  return (
    <div
      style={{
        width: 500,
        minWidth: 500,
        maxWidth: 700,
        borderRadius: 6,
        background: 'white',
        padding: '36px 60px 24px 60px',
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
      }}
    >
      <div className="dome-d-flex dome-flex-column dome-gap24">
        <span className="dome-h2 dome-color-dark-green">new questionnaire terminology</span>
        <span className="dome-p1 dome-color-darkest-grey dome-text-w300">
          A helpful table for processors who are adjusting to our new system updates.
        </span>
        <TableContents />
        <div className="dome-d-flex dome-align-center dome-justify-center">
          <button type="button" onClick={onSave} className="dome-btn dome-btn-base dome-btn-aqua-stroke">
            ok
          </button>
        </div>
      </div>
    </div>
  )
}

const TerminologyModal = ({ open = false, onClose = () => {} }) => {
  const [show, setShow] = useState(open)
  const overlayRef = useRef(null)

  useEffect(() => {
    setShow(open)
  }, [open])

  const handleClose = () => onClose()

  const handleClickOutsideModal = (e) => {
    if (e.target !== overlayRef.current) return
    handleClose()
  }

  return (
    <Portal>
      <div className={clsx('property-setting-modal dome-full-width dome-full-height', show && 'show')}>
        <div
          ref={overlayRef}
          onClick={handleClickOutsideModal}
          className="dome-full-width dome-full-height dome-d-flex dome-align-center dome-justify-center"
        >
          <Terminology onSave={handleClose} />
        </div>
      </div>
    </Portal>
  )
}
export default TerminologyModal
